import { useEffect, useState } from "react";

// Use this hook to check if client specific UI (e.g. hide or show some elements) can be
// applied to the DOM without the React Hydration Error: "Hydration failed due to the UI mismatch…"
// https://nextjs.org/docs/messages/react-hydration-error
const useIsDOMHydratedAfterSSR = () => {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  return hydrated;
};

export default useIsDOMHydratedAfterSSR;
